/** 282/288 — card media aspect ratio (height/width) */
export const HOME_MEDIA_DEFAULT_MEDIA_PADDING_TOP = '97.9%';

export const HOME_MEDIA_CARD_BORDER_RADIUS = 4;
